import React from 'react'
import { getFirstNotEmpty } from '@corratech/pylot-utils/index'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { getCanonical, getFileExtension } from '../util'
import Head from 'next/head'
import { SEO_ENUMS } from '../enums'
import { DefaultOGImage } from '@components/seo/src/ImagePath'

type Page = SEO_ENUMS

export interface BlogLandingInterface {
    mfblog_index_page_title: string
    mfblog_index_page_meta_title: string
    mfblog_index_page_meta_description: string
    mfblog_index_page_meta_keywords: string
}

export type BlogIndexProps = {
    blog: BlogLandingInterface
    pathname: string
    titleOverride?: string
    descriptionOverride?: string
    page?: Page
}

export const BlogIndex = ({
    blog,
    pathname,
    titleOverride,
    descriptionOverride,
    page
}: BlogIndexProps): JSX.Element => {
    const config = useStoreConfig()
    const { seo, base } = config

    const ogImage = `${base.url.baseUrl}${DefaultOGImage}`

    const ogImageAlt =
        seo?.default?.openGraph?.images &&
        seo?.default?.openGraph?.images[0]?.alt

    const title = getFirstNotEmpty([
        titleOverride,
        blog?.mfblog_index_page_meta_title,
        seo.default.title
    ])
    const description = getFirstNotEmpty([
        descriptionOverride,
        blog?.mfblog_index_page_meta_description,
        seo.default.description
    ])
    return (
        <Head>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta
                name="keywords"
                content={String(blog?.mfblog_index_page_meta_keywords)}
            />
            <meta name="description" content={String(description)} />
            <meta property="og:title" content={title} />
            <meta property="og:site_name" content={seo.default.twitter?.site} />
            <link
                rel="canonical"
                href={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta
                property="og:url"
                content={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:alt" content={ogImageAlt} />
            <meta
                property="og:image:type"
                content={`image/${getFileExtension(ogImage!)}`}
            />
            <meta
                name="p:domain_verify"
                content="f000ff9735a3c025e5f36e6833393400"
            />
        </Head>
    )
}
